import Icon from '../components/Icon.vue'

Icon.register({
  'chart-area': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-488c-6.6 0-12-5.4-12-12v-360c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5c6-4 14.2-1.8 17.4 4.7l89.9 187.8h-384v-104l86.8-144.7c4.4-7.3 14.8-7.8 19.9-1l85.3 113.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chart-area.js
// module id = 1168
// module chunks = 0